import React, { useEffect, useState } from 'react'

import './RoomTransition.scss'

const RoomTransition = ({ children, activeScreen, userClicked, i }) => {
  const [className, setClassName] = useState('')
  // const prevActiveScreen = usePrevious(activeScreen)
  useEffect(() => {
    setClassName(activeScreen === i ? 'triggerTransition' : '')
  }, [activeScreen, i])

  return (
    <div className="roomTransition">
      {children}
      <div className={`shutter left ${className} ${!userClicked ? 'hide' : ''}`} />
      <div className={`shutter right ${className} ${!userClicked ? 'hide' : ''}`} />
    </div>
  )
}

export default RoomTransition
